/**
 * 车辆诊断部标机设备参数变更表格
 */
import React, { useState, useEffect, Fragment } from 'react';
import CommonTable from '@/components/commonTable';
import ExportButton from '@/components/exportButton';
import {
  paramInfoListRequest,
  versionInfoListFn,
} from '@/service/carDiagnosis';
import { useTable } from '@/utils/useTable';
import { getDeviceParamsChangeColumns } from '@/columns/jtDeviceError';
import type { DeviceTypeEnum } from '@/constants/deviceManage';

interface JtDeviceErrorTableProps {
  diagnosisSearchParams: any;
  getExportParams: () => any;
  carId?: string,
  deviceType?: DeviceTypeEnum
}
const JtDeviceParamsChangeTable = (props: JtDeviceErrorTableProps) => {
  console.log(props)
  const { diagnosisSearchParams, getExportParams, carId, deviceType } = props;
  const [searchParams, setSearchParams] = useState(null);
  // 监听搜索参数的变化重新获取数据
  useEffect(() => {
    if (carId && diagnosisSearchParams ) {
      setSearchParams({...diagnosisSearchParams, carId});
    }
  }, [diagnosisSearchParams, carId]);

  const { page, limit, loading, data, totalCount, onPageChange } = useTable({
    requestFunc: paramInfoListRequest,
    initRequest: Boolean(searchParams),
    initPageSize: 40,
    searchParams
  });

  return (
    <Fragment>
      <CommonTable
        rowKey="id"
        columns={getDeviceParamsChangeColumns(data, deviceType)}
        dataSource={data}
        pagination={{
          total: totalCount,
          current: page,
          pageSize: limit,
          onChange: onPageChange
        }}
        bordered
        loading={loading}
        scroll={{ x: '100%', y: 400 }}
      />
    </Fragment>
  );
};

export default JtDeviceParamsChangeTable;
